import { ProductBreadcrumbLine } from 'Components/lines/product-breadcrumb-line/ProductBreadcrumbLine';
export default ProductBreadcrumbLine;
